import * as React from "react";

const SvgComponent = () => (
  <svg width="80.000000" height="80.000000" viewBox="0 0 80 80" fill="none">
    <defs>
      <clipPath id="clip1505_1017">
        <rect id="Frame" width="80.000000" height="80.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect id="Frame" width="80.000000" height="80.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1505_1017)">
      <path
        id="Vector"
        d="M6.66797 73.334C6.66797 58.6055 18.6055 46.668 33.3359 46.668L33.3359 53.334C22.2891 53.334 13.3359 62.2891 13.3359 73.334L6.66797 73.334ZM33.3359 43.334C22.2852 43.334 13.3359 34.3848 13.3359 23.334C13.3359 12.2832 22.2852 3.33398 33.3359 3.33398C44.3828 3.33398 53.3359 12.2832 53.3359 23.334C53.3359 34.3848 44.3828 43.334 33.3359 43.334ZM33.3359 36.668C40.7031 36.668 46.668 30.7012 46.668 23.334C46.668 15.9668 40.7031 10 33.3359 10C25.9688 10 20 15.9668 20 23.334C20 30.7012 25.9688 36.668 33.3359 36.668ZM60.9453 49.0098C70.2148 53.1875 76.668 62.5078 76.668 73.334L70 73.334C70 65.2148 65.1641 58.2246 58.2109 55.0918L60.9453 49.0098ZM58.6562 11.3789C65.3164 14.125 70 20.6797 70 28.334C70 37.9004 62.6836 45.752 53.3359 46.5918L53.3359 39.8828C58.9922 39.0742 63.3359 34.2148 63.3359 28.334C63.3359 23.7324 60.6719 19.7539 56.8047 17.8555L58.6562 11.3789Z"
        fill="#AA4040"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
      <path
        id="Vector"
        d="M36.707 64.7539C36.5391 64.0312 36.4492 63.2754 36.4492 62.5C36.4492 61.7246 36.5391 60.9688 36.707 60.2461L34 58.6562L36.7305 53.8438L39.4375 55.4355C40.5117 54.4023 41.8164 53.6211 43.2695 53.1797L43.2695 50L48.7305 50L48.7305 53.1797C50.1836 53.6211 51.4883 54.4023 52.5625 55.4355L55.2695 53.8438L58 58.6562L55.293 60.2461C55.4609 60.9688 55.5508 61.7246 55.5508 62.5C55.5508 63.2754 55.4609 64.0312 55.293 64.7539L58 66.3438L55.2695 71.1562L52.5625 69.5645C51.4883 70.5977 50.1836 71.3789 48.7305 71.8203L48.7305 75L43.2695 75L43.2695 71.8203C41.8164 71.3789 40.5117 70.5977 39.4375 69.5645L36.7305 71.1562L34 66.3438L36.707 64.7539ZM46 66.666C48.2617 66.666 50.0938 64.8008 50.0938 62.5C50.0938 60.1992 48.2617 58.334 46 58.334C43.7383 58.334 41.9062 60.1992 41.9062 62.5C41.9062 64.8008 43.7383 66.666 46 66.666Z"
        fill="#AA4040"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export default SvgComponent;
